/* Copyright (c) 2024, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Locale } from 'date-fns';
import {
    arSA,
    bg,
    cs,
    da,
    de,
    el,
    enGB,
    enUS,
    es,
    fi,
    fr,
    hr,
    hu,
    it,
    ja,
    ko,
    nb,
    nl,
    pl,
    ptBR,
    pt,
    ro,
    ru,
    sk,
    sl,
    sv,
    th,
    tr,
    uk,
    zhCN,
    zhTW
} from 'date-fns/locale';

export const defaultLocale = enUS;

/**
 * List to maintain mapping of locale codes to date-fns's locale codes.
 * This list should be updated if new locale support is added in a project.
 * Refer: https://github.com/date-fns/date-fns/tree/main/src/locale
 */
export const locales: { [key: string]: Locale } = {
    bg_BG: bg,
    cs_CZ: cs,
    da_DK: da,
    de_DE: de,
    el_GR: el,
    en_GB: enGB,
    en_US: enUS,
    es_ES: es,
    es_MX: es,
    fi_FI: fi,
    fr_FR: fr,
    hr_HR: hr,
    hu_HU: hu,
    it_IT: it,
    ja_JP: ja,
    ko_KR: ko,
    nb_NO: nb,
    nl_NL: nl,
    pl_PL: pl,
    pt_BR: ptBR,
    pt_PT: pt,
    ro_RO: ro,
    ru_RU: ru,
    sk_SK: sk,
    sl_SI: sl,
    sv_SE: sv,
    th_TH: th,
    tr_TR: tr,
    uk_UA: uk,
    zh_CN: zhCN,
    zh_TW: zhTW,
    ar_SA: arSA
};
